export default __webpack_public_path__ + "3d7a359783b638fe16783789b5dea4fa.png";